import { Button, Form, FormGroup, Label, Input, Container } from 'reactstrap';
import React, { useState, useEffect } from 'react';
import fetchApi from 'components/Api/Actions';

const AddEditFormAccount = ({ item, addItemToState, updateState, toggle, url }) => {
  const [formData, setFormData] = useState({
    id: 0,
    name: '',
    user: '',
    max_employees: '',
    max_attr: '',
    role: '',
    user_id: ''
  });

  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (item) {
      const { id, name, user, max_employees, max_attr, role, user_id } = item; // Agregado user_id
      setFormData({ id, name, user, max_employees, max_attr, role, user_id }); // Agregado user_id
      const fetchRoles = async () => {
        const rolesData = await fetchApi('roles', { method: 'GET' });
        if (rolesData) {
          setRoles(rolesData);
        } else {
          console.log('Failed to fetch roles');
        }

        const user_account = await fetchApi('user-account/' + user_id + '/' + id, { method: 'GET' });
        if (user_account) {
          setFormData(prevFormData => ({ ...prevFormData, role: user_account.role }));
        } else {
          console.log('Failed to fetch user account role');
        }
      };
      fetchRoles();
    }
  }, [item]);

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const submitFormAdd = async e => {
    e.preventDefault();
    const options = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    };
    const item = await fetchApi('account/', options);
    if (item) {
      addItemToState(item)
      toggle()
    } else {
      toggle();
    }

  };

  const submitFormEdit = async e => {
    e.preventDefault();
    console.log(formData);

    const options = {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    };
    try {
      const item = await fetchApi("account/", options);

      if (item) {
        updateState(item);
        toggle(); // Cierra la modal si `item` es válido
      } else {
        console.log('No se encontró item, cerrando modal');
        toggle(); // Cierra la modal si no se encuentra `item`
      }
    } catch (error) {
      console.error('Error en la solicitud:', error);
      toggle(); // Cierra la modal en caso de error
    }
  };

  return (
    <Form onSubmit={item ? submitFormEdit : submitFormAdd}>
      <FormGroup className='d-none'>
        <Label for="name">User names</Label>
        <Input
          disabled
          type="text"
          name="name"
          id="name"
          onChange={onChange}
          value={formData.name === null ? '' : formData.name}
        />
      </FormGroup>
      <FormGroup>
        <Label for="max_employees">Employee limit</Label>
        <Input
          type="number"
          name="max_employees"
          id="max_employees"
          onChange={onChange}
          value={formData.max_employees === null ? '' : formData.max_employees}
          placeholder="ex. 100"
        />
      </FormGroup>
      <FormGroup>
        <Label for="max_attr">Attribute limit</Label>
        <Input
          type="number"
          name="max_attr"
          id="max_attr"
          onChange={onChange}
          value={formData.max_attr === null ? '' : formData.max_attr}
          placeholder="ex. 5"
        />
      </FormGroup>
      <FormGroup>
        <Label for="role">Role</Label>
        <Input
          type="select"
          name="role"
          id="role"
          onChange={onChange}
          value={formData.role === null ? '' : formData.role}
          required // Hacer el campo obligatorio
        >
          <option value="">Select a role</option>
          {roles.map(role => (
            <option key={role.id} value={role.id}>
              {role.name}
            </option>
          ))}
        </Input>
      </FormGroup>
      <FormGroup className='d-none'>
        <Label for="start_date">Start Date</Label>
        <Input
          disabled
          type="date"
          name="start_date"
          id="start_date"
          onChange={onChange}
          value={formData.start_date === null ? '' : formData.start_date}
        />
      </FormGroup>
      <Container className='d-flex justify-content-end p-0'>
        <Button>Submit</Button>
      </Container>
    </Form>
  );
};

export default AddEditFormAccount;